import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { PersonModel } from '../../person/models/person.model';
import { SharedVehicleGroupAdminModel } from '../models/sharedvehiclegroupadmin.model';
import { SharedVehicleGroupAdminService } from '../models/sharedvehiclegroupadmin.service';


@Component({
  selector: 'wego-add-shredvehiclegroup-admin',
  template: require('../views/add-sharedvehiclegroupadmin-popup.component.html'),
})

export class AddSharedVehicleGroupAdminPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  personList: PersonModel[];
  message: string;
  apiErrorMsg: string;
  urlPersonUpdate: string;
  isLoading: boolean;
  private module: string;
  private breadCrumbTitle: string;
  public sharedVehicleGroupHashId: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('shredVehicleAdminModal') public shredVehicleAdminModal: any;

  constructor(private sharedVehicleGroupAdminService: SharedVehicleGroupAdminService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) { }

  ngOnInit() {
    this.module = this.translate.instant('LblSharedVehicleGroupAdmin');
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);

  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.GetShredVehicleGroupAdminPersonList();
    this.shredVehicleAdminModal.show();
  }

  public hide(): void {
    this.shredVehicleAdminModal.hide();
  }

  private GetShredVehicleGroupAdminPersonList() {
    this.isLoading = true;
    this.sharedVehicleGroupAdminService.GetPersonListBySharedVehicleGroupId(this.sharedVehicleGroupHashId, this.DataListModel)
      .subscribe(
      res => {
        this.personList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(personMasterHashId: string): void {
    this.isLoading = true;
    let model = new SharedVehicleGroupAdminModel();
    model.personHashID = personMasterHashId;
    model.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
    this.sharedVehicleGroupAdminService.AddNewSharedVehicleGroupAdmin(model)
      .subscribe(
      res => {
        this.message = this.translate.instant('LblRecordSavedSuccess')
        this.OnSuccessSelect();
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.shredVehicleAdminModal.hide();
        this.isLoading = false;
      });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetShredVehicleGroupAdminPersonList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetShredVehicleGroupAdminPersonList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetShredVehicleGroupAdminPersonList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetShredVehicleGroupAdminPersonList();
  }

  private OnSuccessSelect() {
    this.onSuccessSelect.emit({ SuccessMessage: this.message })
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupadmin/components/add-sharedvehiclegroupadmin-popup.component.ts